let preloaded = false;

export function preloadExpressCheckoutChunks(): void {
  if (preloaded) {
    return;
  }
  preloaded = true;
  void import('@/components/PaypalExpressButton/PaypalExpressButton');
  void import('@/components/ApplePayExpressButton/ApplePayExpressButton');
}
